export default {
  slugs: {
    'questions-du-moment': 'questions',
  },
}
